import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";
import classNames from "classnames";

interface Props extends PropsWithChildren<ComponentPropsWithoutRef<"span">> {
  label?: string;
  iconPosition?: "right" | "left";
  icon?: React.ReactNode;
  textColor?: string;
  bgColor?: string;
  //color?: string;
}

const Pill = (props: Props) => {
  return (
    <>
      {props.label && (
        <div
          // tailwind issue: color cannot be variable unless the class has been called somewhere before
          // https://stackoverflow.com/questions/70907369/color-classes-of-tailwind-css-not-working-when-appended
          // className={twMerge(
          //   classNames(
          //     "inline-flex flex-row items-center gap-x-1 rounded-full px-2.5 py-1 text-xs font-bold",
          //     `bg-${props.color}-100`,
          //     `text-${props.color}-500`
          //   )
          // )}
          data-testid="pill"
          className={twMerge(
            classNames(
              "inline-flex flex-row items-center gap-x-1 rounded-full px-2.5 py-1 text-xs font-bold",
              props.textColor,
              props.bgColor
            )
          )}
        >
          {props.iconPosition === "left" && props.icon}
          <span data-testid="pill-label">{props.label}</span>
          {props.iconPosition === "right" && props.icon}
          {props.children}
        </div>
      )}
    </>
  );
};

export default Pill;
